import React, { createContext, useContext, useState, ReactNode } from 'react';

export type CustomTimingFormValues = {
  repeatEvery: number;
  repeatType: string;
  weeklyDays: number[];
  monthlyDates: number[];
  endCondition: string;
  endDate?: string;
  occurrences?: number;
};

type CustomTimingContextType = {
  customTimingData: CustomTimingFormValues | null;
  setCustomTimingData: (data: CustomTimingFormValues | null) => void;
  clearCustomTimingData: () => void;
};

const CustomTimingContext = createContext<CustomTimingContextType | undefined>(undefined);

type CustomTimingContextProviderProps = {
  children: ReactNode;
};

export const CustomTimingContextProvider: React.FC<CustomTimingContextProviderProps> = ({ children }) => {
  const [customTimingData, setCustomTimingData] = useState<CustomTimingFormValues | null>(null);

  const clearCustomTimingData = () => {
    setCustomTimingData(null);
  };

  const value: CustomTimingContextType = {
    customTimingData,
    setCustomTimingData,
    clearCustomTimingData,
  };

  return (
    <CustomTimingContext.Provider value={value}>
      {children}
    </CustomTimingContext.Provider>
  );
};

export const useCustomTiming = (): CustomTimingContextType => {
  const context = useContext(CustomTimingContext);
  if (context === undefined) {
    throw new Error('useCustomTiming must be used within a CustomTimingContextProvider');
  }
  return context;
};